import { render } from "./EntityIframeWrapper.vue?vue&type=template&id=a090f90e&scoped=true"
import script from "./EntityIframeWrapper.vue?vue&type=script&lang=js"
export * from "./EntityIframeWrapper.vue?vue&type=script&lang=js"

import "./EntityIframeWrapper.vue?vue&type=style&index=0&id=a090f90e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a090f90e"]])

export default __exports__